// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';
import { nativeAuthStorage } from '../../native/authStorage';

const SUPABASE_URL = "https://ruamgnhtybcahvtzwtem.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ1YW1nbmh0eWJjYWh2dHp3dGVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3NTcyNzQsImV4cCI6MjA3MTMzMzI3NH0.__IDSWhwfS0nX2jr0otugiXLgb14QOQrQvzb0VrT9Yk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: nativeAuthStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
